import { render, staticRenderFns } from "./walletRecord.vue?vue&type=template&id=33c44a24&scoped=true&"
import script from "./walletRecord.vue?vue&type=script&lang=js&"
export * from "./walletRecord.vue?vue&type=script&lang=js&"
import style0 from "./walletRecord.vue?vue&type=style&index=0&id=33c44a24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c44a24",
  null
  
)

export default component.exports